export const TOMB_TICKER = 'FUDGE';
export const TSHARE_TICKER = 'STRAW';
export const TBOND_TICKER = 'CARAML';
export const FTM_TICKER = 'DAI';
export const WFTM_TICKER = 'DAI';
export const AVAX_TICKER = 'WAVAX';
export const SPOOKY_ROUTER_ADDR = '0x60aE616a2155Ee3d9A68541Ba4544862310933d4';
export const ZAPPER_ROUTER_ADDR = '0x110F74F014cCD5bC23509bEDd7277B003DD0B15B';
export const TAX_OFFICE_ADDR = '0x2A637BEE0D76136d8ee44B96cf0A5f9198657AaF';